import { createHead } from '@unhead/vue/client'
import i18n from './i18n'
import getEnvironment from '@/utils/env'
import { getIntlLocales } from '@/utils/format'

const env = getEnvironment()

const unhead = createHead({
  init: [
    {
      titleTemplate: (title) => {
        const prefix =
          env != null && env.id !== 'production'
            ? `[${env.name?.substring(0, 2).toLocaleUpperCase(getIntlLocales())}] `
            : ''
        return title ? `${prefix}${title} | Mitt Amili` : `${prefix}Mitt Amili`
      },
      htmlAttrs: {
        lang: () => i18n.global.locale.value,
      },
      // No per-environment favicon links — the customer portal ships a single
      // favicon set via index.html (no favicon-{env}.png assets exist).
    },
  ],
})

export default unhead
